import { z } from "zod";

export const healthSchema = z.object({
  status: z.enum(["ok", "degraded"]),
  database: z.enum(["ok", "unreachable"]),
  /** Whether the contact form can take a message: it needs the spam check configured. */
  contact: z.enum(["accepting", "not_configured"]),
  /** How many messages are waiting for Orla to collect. */
  waitingForOrla: z.number().int().nonnegative(),
});

export type Health = z.infer<typeof healthSchema>;
